import { render, staticRenderFns } from "./PolicyAndTerms.vue?vue&type=template&id=5ff44cb2&"
import script from "./PolicyAndTerms.vue?vue&type=script&lang=ts&setup=true&"
export * from "./PolicyAndTerms.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ff44cb2')) {
      api.createRecord('5ff44cb2', component.options)
    } else {
      api.reload('5ff44cb2', component.options)
    }
    module.hot.accept("./PolicyAndTerms.vue?vue&type=template&id=5ff44cb2&", function () {
      api.rerender('5ff44cb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/profile/doctors/register/index/DoctorsRegisterContent/components/RegistrationForm/components/PolicyAndTerms.vue"
export default component.exports